import AxiosInstanceCreator from 'services/api';
import qs from "qs";
const authInstance = new AxiosInstanceCreator().create();

export const frsApi = {
  async getFrsUserList(param: any) {
    return await authInstance.get(`/biostar/user-list?${qs.stringify(param)}`).then((res) => res.data);
  },
  async syncFrsUserData() {
    return await authInstance.get(`/biostar/sync-user`).then((res) => res.data);
  },
  async removeFrsUserData(userIds: string[]) {
    return await authInstance.post(`/biostar/remove-users`, userIds).then((res) => res.data);
  },
  async margeFrsUserData(users: any[]) {
    return await authInstance.post(`/biostar/marge-users`, users).then((res) => res.data);
  }
};
